import React from "react";
import Icon from "./Icon";
import "./SectionHeader.css";

// Section header: gradient icon chip + title (+ optional right slot).
export default function SectionHeader({ icon, title, accent = "violet", right }) {
  return (
    <div className="sec-head">
      <span className={`sec-ico ${accent}`}><Icon name={icon} size={18} /></span>
      <span className="sec-title">{title}</span>
      {right && <span className="sec-right">{right}</span>}
    </div>
  );
}
